export default {"src":"/_next/static/media/invite.11ab495b.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};